import { Button } from '@components/base';
import css from './index.module.scss';
import OrderDetailContainer from './order-detail-container';
import { useFormContext } from 'react-hook-form';
import { useBeforeUnloadAndNavigate } from '@helpers/hooks';
import { AddOrderStates } from '@pages/order/add-order';

interface OrderDetailFormProps {
  onFormSubmit: (data: any) => void;
  onCancelClick?: () => void;
  onBackClick?: () => void;
  rectifyRemarks?: string;
  countryOptions?: Array<{ label: any; value: any }>;
  orderState?: AddOrderStates;
}

const OrderDetailForm = (props: OrderDetailFormProps) => {
  const { onCancelClick, onFormSubmit, onBackClick, rectifyRemarks, countryOptions, orderState } =
    props;
  const {
    handleSubmit,
    formState: { isSubmitting }
  } = useFormContext();

  useBeforeUnloadAndNavigate();

  return (
    <form noValidate onSubmit={handleSubmit(onFormSubmit)} className={css.formWrapper}>
      <OrderDetailContainer
        rectifyRemarks={rectifyRemarks}
        countryOptions={countryOptions}
        orderState={orderState}
      />
      <div className={css.actionBtnWrapper}>
        <Button variant="text" onClick={onCancelClick}>
          Cancel
        </Button>
        <div>
          <Button variant="outlined-secondary" onClick={onBackClick} className={css.nextBtn}>
            Back
          </Button>
          <Button type="submit" disabled={isSubmitting}>
            Save and Proceed
          </Button>
        </div>
      </div>
    </form>
  );
};

export default OrderDetailForm;
